export default "__VITE_ASSET__760320fc__"